export default __webpack_public_path__ + "static/media/arrowBg.1b4fd102.svg";